import { WebappsCidApi } from '../apis/webapps-cid.api';
import { id } from '@monorepo/tools/src/lib/types/primitives';

export async function hasLinkedWebappsCidSegments(cid: id): Promise<boolean> {
	const res = await WebappsCidApi.getSegments(cid);
	return (res.cid_segments ?? []).some(segment => segment.target_cid != null && segment.target_cid !== '');
}
